<template>
  <div class="login_in" :id="nodeName">
    <div v-if="!isRegister">
      <img v-show="isShow" class="loginCut" @click="delu" :src="login_pc" alt="">
      <img v-show="!isShow" class="loginCut" @click="delu" :src="login_weixing" alt="">
    </div>
    <h4>

      <div v-if="!isRegister">
        <span v-show="isShow" class="log_act">微信登录/注册</span>
      </div>
      <span v-show="!isShow" class="log_act">{{loginTit}}</span>
    </h4>
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="0px" class="ruleForm"
      v-if="!isShow">
      <p style="float:left">{{loginTitName}}</p>
      <el-form-item label prop="loginName">
        <el-input v-if="!$privatization" v-model="ruleForm.loginName" placeholder="输入手机号/邮箱"
          @keyup.enter.native="submitForm('ruleForm')">
        </el-input>
        <el-input v-if="$privatization" v-model="ruleForm.loginName" type="tel" placeholder="输入用户名"
          @keyup.enter.native="submitForm('ruleForm')">
        </el-input>
      </el-form-item>
      <p style="float:left">输入密码</p>
      <el-form-item label prop="password">
        <el-input type="password" v-model="ruleForm.password" placeholder="输入密码" show-password
          @keyup.enter.native="submitForm('ruleForm')"></el-input>
      </el-form-item>
      <dragBox ref="drag" @drag="drag" :key="dragKey"></dragBox>

      <p v-if="!isRegister" style="float:right;margin-top:5px;margin-bottom:10px;cursor:pointer;" class="forget"
        @click="register">忘记密码？
      </p>
      <!-- <el-form-item> -->
      <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
      <!-- </el-form-item> -->
      <p v-if="!isRegister" class="register" type @click="loginRegister">没有账号？去注册</p>
    </el-form>
    <div v-if="!isRegister">
      <div id="wxImg" v-show="isShow">
        <img :src="'data:image/png;base64,' + wxImgSrc" alt="微信二维码" />
        <span v-show="loadingIcon"><i class="el-icon-loading"></i>&nbsp;登录中</span>
        <!-- <span v-show="!loadingIcon">扫码关注中科凡语公众号登录</span> -->
        <div class="upBox" v-if="wxUp" @click="wxRefresh">
          <span>二维码失效，请刷新页面</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var interval;
import dragBox from "@/common/dragBox.vue"; // 引入滑动条
// import wxlogin from "vue-wxlogin";
// import weixing from '@/views/login/weixing.vue'
import md5 from "js-md5";
export default {
  name: "login_in",
  components: {
    dragBox
  },
  data() {

    var username = (rule, value, callback) => {
      if (this.$privatization) {
        if (!value) {
          return callback(new Error("请填写用户名"));
        } else {
          callback();
        }
      } else {
        let reg = /^1\d{10}$/;
        let email = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
        if (!value) {
          return callback(new Error("手机号/邮箱不能为空"));
        }
        if (value.indexOf("@") === -1) {
          if (!reg.test(value)) {
            return callback(new Error("手机号不正确"));
          }
        } else {
          if (!email.test(value)) {
            return callback(new Error("邮箱不正确"));
          }
        }
        callback();
      }

    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码长度不能小于6个字符"));
      } else if (value.length > 16) {
        callback(new Error("密码长度不能超过16个字符"));
      }
      callback();
    };
    return {
      ruleForm: {
        loginName: "",
        password: ""
      },
      rules: {
        loginName: [{ required: true, validator: username, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }]
      },
      isShow: true,
      dragOk: false,
      appid: "",
      wxImgSrc: "",
      wxState: "",
      wxInter: null,
      loadingIcon: false,
      wxUp: false,
      nodeName: "",
      isRegister: false,
      login_pc: require('../../assets/imgs/login/erweima.png'),//erweima
      login_weixing: require('../../assets/imgs/login/iphone.png'),
      loginTit: "手机号/邮箱登录",
      loginTitName: "手机号/邮箱",
      dragKey: 1
    };
  },
  created() {
    if (this.$route.params.isShow) {
      this.isShow = false
    } else {
      this.nodeName = process.env.VUE_APP_NAME;

      if (this.nodeName === "drill" || this.nodeName === "shanghai") {
        this.isRegister = true;
        this.isShow = false;
        this.loginTit = "账号登录"
        this.loginTitName = "用户名"
        this.login_pc = require('../../assets/imgs/login/erweima.png');
        this.login_weixing = require('../../assets/imgs/login/iphone.png')
      } else if (this.nodeName === "school" || this.nodeName === "nation") {
        this.isShow = false

      } else {
        this.getWX();
      }

      if (process.env.NODE_ENV === "production") {
        this.appid = "wx5bee8f63fa3a45e2"; // 正式环境
      } else {
        this.appid = "wx82c1a47b01583c15";
      }
    }

  },

  beforeDestroy() {
    clearInterval(this.wxInter);
  },
  beforeRouteEnter(to, from, next) {
    if (window.innerWidth > 992 && window.innerWidth < 1400) {
      document.body.style.zoom = 0.8;
    }
    next();
  },
  methods: {
    // 刷新页面
    wxRefresh() {
      this.getWX();
      this.wxUp = false;
      // this.$router.go(0);
    },
    //register
    loginRegister() {
      this.$emit("func", 1)
      // this.$router.push({ name: "login_register" })
    },
    getUser() {
      // 判断用户是否关联手机号
      let myPhone = localStorage.getItem("myPhone");
      let myEmail = localStorage.getItem("myEmail");
      this.loadingIcon = false;
      if (myPhone !== "" || myEmail !== "") {
        this.$router.replace({ name: "home" }); // 跳到首页
      } else {
        this.$emit("func", 4)// 跳到关联手机号组件
        // this.$router.replace({ name: "relation", params: { userId: "123" } });
      }
    },
    // 二维码登录
    wxLogin(data) {
      localStorage.setItem("openid", data);
      let that = this;
      this.loadingIcon = true;
      let platformType// = this.nodeName === "drill" ? 5 : undefined;
      if (this.nodeName === "drill") {
        platformType = 5
        //nation
      } else if (this.nodeName === "nation") {
        platformType = 6
      } else {
        platformType = undefined
      }
      this.catReq1Service("/user/loginByOpenId", { openId: data, platformType }).then(
        function (response) {
          if (!response.success) {
            return;
          }
          var data = response.result;
          var val = JSON.stringify(data);
          localStorage.setItem("myUser", val);
          if (response.resultCode === "1") {
            localStorage.setItem("myPhone", data.loginPhone); // 电话
            localStorage.setItem("myId", data.selfCompany.id);
            localStorage.setItem("myUserImg", data.avatar); // 头像
            localStorage.setItem("myUserName", data.nickName); // 昵称
            localStorage.setItem("myAliasName", data.aliasName); // 别名  --
            localStorage.setItem("myEmail", data.email); // 邮箱
            localStorage.setItem("myCompanyCode", data.selfCompany.code); // 公司编码
            that.getUser(); // 判断用户是否绑定手机号
          }
        }
      );
    },
    /// 轮询 是否扫二维码
    getWXStatus() {
      var that = this;
      this.catReq1Service(
        "/wechat/get_openId",
        { state: this.wxState },
        "post",
        2
      ).then(function (response) {
        if (response.resultCode == "0") {
          that.wxUp = true;
          clearInterval(that.wxInter);
          return;
        }
        let data = response.result;
        if (data != null) {
          if (data.resultCode === "0") {
            clearInterval(that.wxInter);
            if (data.errorDesc === "用户无权登陆") {
              that.$message.closeAll();
              that.$message({
                message: "暂无登录权限，请联系管理员。或飞译官方客服：13717630007",
                type: "warning"
              });
              that.getWX();
              return
            }
            that.wxUp = true;
          } else {
            clearInterval(that.wxInter);
            that.wxLogin(data.result.openId);
          }
        }
      });
      // }, 1000);
      // console.log(this.wxState,"this.wxState")
    },
    // 获取二维码
    getWX() {
      clearInterval(this.wxInter);
      let that = this;
      this.isShow = true;
      this.catReq1Service("/wechat/get_wechat_login_url").then(function (
        response
      ) {
        if (!response.success) {
          return;
        }
        that.wxImgSrc = response.result.urlBase64;
        that.wxState = response.result.state;
        // that.getWXStatus();
        that.wxInter = window.setInterval(that.getWXStatus, 1000);
      });
    },


    // 滑动条事件
    drag(data) {
      this.dragOk = data;
    },
    // 登录
    submitForm(formName) {

      var that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.dragOk) {
            this.$message.closeAll();
            this.$message({
              message: "请按住滑块,拖动到最右边!",
              type: "warning"
            });
            return;
          }
          let platformType// = this.nodeName === "drill" ? 5 : undefined;
          if (this.nodeName === "drill") {
            platformType = 5
            //nation
          } else if (this.nodeName === "nation") {
            platformType = 6
          } else {
            platformType = undefined
          }

          let params = {
            loginName: this.ruleForm.loginName,
            password: md5(this.ruleForm.password),
            platformType
          };
          this.catReq1Service("/user/login", params).then(function (response) {
            if (!response.success) {
              that.dragKey++
              that.dragOk = false;
              return;
            }
            var data = response.result;
            var val = JSON.stringify(data);
            if (response.resultCode === "1") {
              // localStorage.setItem("myId", data.id);
              localStorage.setItem("myUser", val);
              localStorage.setItem("myUserImg", data.avatar); // 头像
              localStorage.setItem("myUserName", data.nickName); // 昵称
              localStorage.setItem("myAliasName", data.aliasName); // 别名
              localStorage.setItem("myPhone", data.loginPhone); // 电话
              localStorage.setItem("openid", data.openid); // 电话
              localStorage.setItem("myEmail", data.email); // 邮箱
              if (that.$privatization) { // 私有部署
                localStorage.setItem("myCompanyCode", data.companyList[0].code);
              } else {
                localStorage.setItem("myCompanyCode", data.selfCompany.code); // 公司编码

              }
              // that.$router.push({ name: "home" }); // 跳到首页
              that.$store.state.rou = true;

              that.$router.replace({ name: "home" }); // 跳到首页
            } else {
              that.$message.error(response.errorDesc);
            }
          });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    // 跳注册 忘记密码
    register() {
      this.$emit("func", 2)
      // this.$router.push({ name: "login_up" });

    },
    delu() {
      if (this.isShow) {
        this.isShow = false;
        clearInterval(this.wxInter);
      } else {
        this.isShow = true;
        if (this.nodeName === "school" || this.nodeName === "nation") {
          this.getWX();
        } else {
          this.wxInter = window.setInterval(this.getWXStatus, 1000);
        }


      }
    }
  }
};
</script>
<style lang="less" scoped>
#drill {
  .log_act {
    color: rgba(33, 71, 145, 1);
  }
  .ruleForm {
    .forget {
      color: rgba(55, 110, 223, 1);
    }
    .register {
      color: rgba(32, 75, 163, 1);
    }
    button {
      background: rgba(49, 111, 209, 1);
      border: none;
      margin-top: 30px;
    }
    /deep/.el-input__inner {
      color: rgba(76, 129, 184, 1);
    }
  }
}
#shanghai {
  .log_act {
    color: rgba(33, 71, 145, 1);
  }
  .ruleForm {
    .forget {
      color: rgba(55, 110, 223, 1);
    }
    .register {
      color: rgba(32, 75, 163, 1);
    }
    button {
      background: rgba(49, 111, 209, 1);
      border: none;
      margin-top: 30px;
    }
    /deep/.el-input__inner {
      color: rgba(76, 129, 184, 1);
    }
  }
}
.login_in {
  text-align: center;
  // width: 300px;
  // height: 370px;
  background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 10px 10px 0px rgba(137, 137, 137, 0.13);
  border-radius: 10px;
  // padding: 50px;
  padding: 70px 80px 0 80px;
  position: relative;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  // right: 120px;
  .loginCut {
    position: absolute;
    top: 0px;
    right: 0px;
    cursor: pointer;
    //  width: 60px;
  }
  h4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    padding: 0 10px;
    margin-bottom: 30px;
    span {
      // cursor: pointer;
    }
    // span:nth-child(1) {
    //   float: left;
    //   // text-align: center;
    // }
    // span:nth-child(2) {
    //   float: right;
    // }
    .log_act {
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
      font-size: 18px;
    }
  }
  .ruleForm {
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    p {
      margin-bottom: 5px;
    }
    /deep/.el-input__inner {
      height: 36px;
      line-height: 36px;
      border: 1px solid rgba(192, 192, 192, 1);
      border-radius: 2px;
    }
    button {
      width: 100%;
      height: 36px;
      background: #216fe5;
      border: none;
      border-radius: 2px;
      line-height: 0px;
    }
    .register {
      color: rgba(69, 69, 69, 1);
      margin-top: 10px;
      text-align: right;
      cursor: pointer;
    }
    .el-form-item {
      margin-bottom: 24px;
    }
  }
  .weixing {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // #wxImg {
    //   width: 250px;
    //   height: 250px;
    //   border: 1px solid rgba(167, 167, 167, 1);
    //   border-radius: 4px;
    // }
    p {
      position: relative;
      top: 10px;
      left: -40px;
      font-size: 12px;
    }
  }
}
#wxImg {
  width: 254px;
  height: 254px;
  border: 1px solid;
  border-radius: 4px;
  margin: 0 auto;
  position: relative;
  .upBox {
    position: absolute;
    width: 97%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 97%;
    background: rgba(255, 255, 255, 0.9);
    z-index: 50;
    cursor: pointer;
    font-weight: 600;
    span {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  img {
    // width: 100%;
    // height: 100%;
    // border: 1px solid #999999;
    // border-radius: 4px;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    margin-bottom: 20px;
  }
  span {
    font-size: 18px;
    width: 100%;
    text-align: center;
  }
  i {
    font-size: 20px;
  }
}
</style>
<style lang="less">
#wx_default_tip {
  display: none;
}
.status_browser {
  display: none;
}
</style>
